module.exports = __webpack_public_path__ + "img/mang2.e1d5c930.jpg";